import React from "react"

import NavMenuPrimary from "../nav-menu-primary"
import NavMenuSecondary from "../nav-menu-secondary"
import * as styles from "./index.module.scss"

const Nav = () => {
  return (
    <nav role="navigation" className={styles.navMenu}>
      <div className={styles.navWrapper}>
        <NavMenuPrimary />
        <NavMenuSecondary />
      </div>
    </nav>
  )
}

export default Nav
